/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { customerDomainsCheckIsDomainOwner } from '../fn/customer-domains/customer-domains-check-is-domain-owner';
import { CustomerDomainsCheckIsDomainOwner$Params } from '../fn/customer-domains/customer-domains-check-is-domain-owner';
import { customerDomainsCreateGet } from '../fn/customer-domains/customer-domains-create-get';
import { CustomerDomainsCreateGet$Params } from '../fn/customer-domains/customer-domains-create-get';
import { customerDomainsCreatePost } from '../fn/customer-domains/customer-domains-create-post';
import { CustomerDomainsCreatePost$Params } from '../fn/customer-domains/customer-domains-create-post';
import { customerDomainsDelete } from '../fn/customer-domains/customer-domains-delete';
import { CustomerDomainsDelete$Params } from '../fn/customer-domains/customer-domains-delete';
import { customerDomainsGetCurrentClientData } from '../fn/customer-domains/customer-domains-get-current-client-data';
import { CustomerDomainsGetCurrentClientData$Params } from '../fn/customer-domains/customer-domains-get-current-client-data';
import { customerDomainsGetCustomerDomainById } from '../fn/customer-domains/customer-domains-get-customer-domain-by-id';
import { CustomerDomainsGetCustomerDomainById$Params } from '../fn/customer-domains/customer-domains-get-customer-domain-by-id';
import { customerDomainsGetCustomerDomainsAudit } from '../fn/customer-domains/customer-domains-get-customer-domains-audit';
import { CustomerDomainsGetCustomerDomainsAudit$Params } from '../fn/customer-domains/customer-domains-get-customer-domains-audit';
import { customerDomainsGetCustomerDomainsWithPagination } from '../fn/customer-domains/customer-domains-get-customer-domains-with-pagination';
import { CustomerDomainsGetCustomerDomainsWithPagination$Params } from '../fn/customer-domains/customer-domains-get-customer-domains-with-pagination';
import { customerDomainsGetLink } from '../fn/customer-domains/customer-domains-get-link';
import { CustomerDomainsGetLink$Params } from '../fn/customer-domains/customer-domains-get-link';
import { customerDomainsGetUserDomains } from '../fn/customer-domains/customer-domains-get-user-domains';
import { CustomerDomainsGetUserDomains$Params } from '../fn/customer-domains/customer-domains-get-user-domains';
import { customerDomainsUpdateGet } from '../fn/customer-domains/customer-domains-update-get';
import { CustomerDomainsUpdateGet$Params } from '../fn/customer-domains/customer-domains-update-get';
import { customerDomainsUpdatePut } from '../fn/customer-domains/customer-domains-update-put';
import { CustomerDomainsUpdatePut$Params } from '../fn/customer-domains/customer-domains-update-put';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfBoolean } from '../models/custom-result-of-boolean';
import { CustomResultOfGetCurrentClientDataDto } from '../models/custom-result-of-get-current-client-data-dto';
import { CustomResultOfGetCustomerDomainByIdDto } from '../models/custom-result-of-get-customer-domain-by-id-dto';
import { CustomResultOfIListOfGetUserDomainsDto } from '../models/custom-result-of-i-list-of-get-user-domains-dto';
import { CustomResultOfPaginatedListOfCustomerDomainDto } from '../models/custom-result-of-paginated-list-of-customer-domain-dto';
import { CustomResultOfString } from '../models/custom-result-of-string';

@Injectable({ providedIn: 'root' })
export class CustomerDomainsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `customerDomainsGetCustomerDomainById()` */
  static readonly CustomerDomainsGetCustomerDomainByIdPath = '/CustomerDomains/GetCustomerDomainById';

  /**
   * Get CustomerDomain By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsGetCustomerDomainById()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsGetCustomerDomainById$Response(params?: CustomerDomainsGetCustomerDomainById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetCustomerDomainByIdDto>> {
    return customerDomainsGetCustomerDomainById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get CustomerDomain By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsGetCustomerDomainById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsGetCustomerDomainById(params?: CustomerDomainsGetCustomerDomainById$Params, context?: HttpContext): Observable<CustomResultOfGetCustomerDomainByIdDto> {
    return this.customerDomainsGetCustomerDomainById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetCustomerDomainByIdDto>): CustomResultOfGetCustomerDomainByIdDto => r.body)
    );
  }

  /** Path part for operation `customerDomainsGetCurrentClientData()` */
  static readonly CustomerDomainsGetCurrentClientDataPath = '/CustomerDomains/GetCurrentClientData';

  /**
   * Get Current Client Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsGetCurrentClientData()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsGetCurrentClientData$Response(params?: CustomerDomainsGetCurrentClientData$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetCurrentClientDataDto>> {
    return customerDomainsGetCurrentClientData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Current Client Data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsGetCurrentClientData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsGetCurrentClientData(params?: CustomerDomainsGetCurrentClientData$Params, context?: HttpContext): Observable<CustomResultOfGetCurrentClientDataDto> {
    return this.customerDomainsGetCurrentClientData$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetCurrentClientDataDto>): CustomResultOfGetCurrentClientDataDto => r.body)
    );
  }

  /** Path part for operation `customerDomainsGetUserDomains()` */
  static readonly CustomerDomainsGetUserDomainsPath = '/CustomerDomains/GetUserDomains';

  /**
   * Get User Domains For dropdown.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsGetUserDomains()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsGetUserDomains$Response(params?: CustomerDomainsGetUserDomains$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfIListOfGetUserDomainsDto>> {
    return customerDomainsGetUserDomains(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User Domains For dropdown.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsGetUserDomains$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsGetUserDomains(params?: CustomerDomainsGetUserDomains$Params, context?: HttpContext): Observable<CustomResultOfIListOfGetUserDomainsDto> {
    return this.customerDomainsGetUserDomains$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfIListOfGetUserDomainsDto>): CustomResultOfIListOfGetUserDomainsDto => r.body)
    );
  }

  /** Path part for operation `customerDomainsGetCustomerDomainsWithPagination()` */
  static readonly CustomerDomainsGetCustomerDomainsWithPaginationPath = '/CustomerDomains/GetCustomerDomainsWithPagination';

  /**
   * For each user get CustomerDomains with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsGetCustomerDomainsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerDomainsGetCustomerDomainsWithPagination$Response(params: CustomerDomainsGetCustomerDomainsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfCustomerDomainDto>> {
    return customerDomainsGetCustomerDomainsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get CustomerDomains with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsGetCustomerDomainsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerDomainsGetCustomerDomainsWithPagination(params: CustomerDomainsGetCustomerDomainsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfCustomerDomainDto> {
    return this.customerDomainsGetCustomerDomainsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfCustomerDomainDto>): CustomResultOfPaginatedListOfCustomerDomainDto => r.body)
    );
  }

  /** Path part for operation `customerDomainsGetCustomerDomainsAudit()` */
  static readonly CustomerDomainsGetCustomerDomainsAuditPath = '/CustomerDomains/GetCustomerDomainsAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsGetCustomerDomainsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerDomainsGetCustomerDomainsAudit$Response(params: CustomerDomainsGetCustomerDomainsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return customerDomainsGetCustomerDomainsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsGetCustomerDomainsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerDomainsGetCustomerDomainsAudit(params: CustomerDomainsGetCustomerDomainsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.customerDomainsGetCustomerDomainsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `customerDomainsCreateGet()` */
  static readonly CustomerDomainsCreateGetPath = '/CustomerDomains/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsCreateGet$Response(params?: CustomerDomainsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return customerDomainsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsCreateGet(params?: CustomerDomainsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.customerDomainsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `customerDomainsCreatePost()` */
  static readonly CustomerDomainsCreatePostPath = '/CustomerDomains/Create';

  /**
   * Create CustomerDomain.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerDomainsCreatePost$Response(params: CustomerDomainsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return customerDomainsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create CustomerDomain.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerDomainsCreatePost(params: CustomerDomainsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.customerDomainsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `customerDomainsUpdatePut()` */
  static readonly CustomerDomainsUpdatePutPath = '/CustomerDomains/Update/{id}';

  /**
   * Update CustomerDomain.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerDomainsUpdatePut$Response(params: CustomerDomainsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return customerDomainsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update CustomerDomain.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerDomainsUpdatePut(params: CustomerDomainsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.customerDomainsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `customerDomainsUpdateGet()` */
  static readonly CustomerDomainsUpdateGetPath = '/CustomerDomains/Update';

  /**
   * Get CustomerDomain By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsUpdateGet$Response(params?: CustomerDomainsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetCustomerDomainByIdDto>> {
    return customerDomainsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get CustomerDomain By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsUpdateGet(params?: CustomerDomainsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetCustomerDomainByIdDto> {
    return this.customerDomainsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetCustomerDomainByIdDto>): CustomResultOfGetCustomerDomainByIdDto => r.body)
    );
  }

  /** Path part for operation `customerDomainsDelete()` */
  static readonly CustomerDomainsDeletePath = '/CustomerDomains/Delete';

  /**
   * Delete CustomerDomain.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsDelete$Response(params?: CustomerDomainsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return customerDomainsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete CustomerDomain.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsDelete(params?: CustomerDomainsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.customerDomainsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `customerDomainsGetLink()` */
  static readonly CustomerDomainsGetLinkPath = '/CustomerDomains/GetLink';

  /**
   * Get CustomerDomain Link.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsGetLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsGetLink$Response(params?: CustomerDomainsGetLink$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return customerDomainsGetLink(this.http, this.rootUrl, params, context);
  }

  /**
   * Get CustomerDomain Link.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsGetLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsGetLink(params?: CustomerDomainsGetLink$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.customerDomainsGetLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `customerDomainsCheckIsDomainOwner()` */
  static readonly CustomerDomainsCheckIsDomainOwnerPath = '/CustomerDomains/CheckIsDomainOwner';

  /**
   * بررسی اینکه سازمان جاری مالک دامنه است یا نه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerDomainsCheckIsDomainOwner()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsCheckIsDomainOwner$Response(params?: CustomerDomainsCheckIsDomainOwner$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfBoolean>> {
    return customerDomainsCheckIsDomainOwner(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی اینکه سازمان جاری مالک دامنه است یا نه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerDomainsCheckIsDomainOwner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerDomainsCheckIsDomainOwner(params?: CustomerDomainsCheckIsDomainOwner$Params, context?: HttpContext): Observable<CustomResultOfBoolean> {
    return this.customerDomainsCheckIsDomainOwner$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfBoolean>): CustomResultOfBoolean => r.body)
    );
  }

}
